export type HttpStatusType = {
  readonly CODE: number,
};

export type HttpStatusesType = {
  readonly CONTINUE: HttpStatusType,
  readonly SWITCHING_PROTOCOLS: HttpStatusType,
  readonly PROCESSING: HttpStatusType,
  readonly EARLY_HINTS: HttpStatusType,
  readonly OK: HttpStatusType,
  readonly CREATED: HttpStatusType,
  readonly ACCEPTED: HttpStatusType,
  readonly NON_AUTHORITATIVE_INFORMATION: HttpStatusType,
  readonly NO_CONTENT: HttpStatusType,
  readonly RESET_CONTENT: HttpStatusType,
  readonly PARTIAL_CONTENT: HttpStatusType,
  readonly MULTI_STATUS: HttpStatusType,
  readonly ALREADY_REPORTED: HttpStatusType,
  readonly IM_USED: HttpStatusType,
  readonly MULTIPLE_CHOICES: HttpStatusType,
  readonly MOVED_PERMANENTLY: HttpStatusType,
  readonly FOUND: HttpStatusType,
  readonly SEE_OTHER: HttpStatusType,
  readonly NOT_MODIFIED: HttpStatusType,
  readonly USE_PROXY: HttpStatusType,
  readonly SWITCH_PROXY: HttpStatusType,
  readonly TEMPORARY_REDIRECT: HttpStatusType,
  readonly PERMANENT_REDIRECT: HttpStatusType,
  readonly BAD_REQUEST: HttpStatusType,
  readonly UNAUTHORIZED: HttpStatusType,
  readonly PAYMENT_REQUIRED: HttpStatusType,
  readonly FORBIDDEN: HttpStatusType,
  readonly NOT_FOUND: HttpStatusType,
  readonly METHOD_NOT_ALLOWED: HttpStatusType,
  readonly NOT_ACCEPTABLE: HttpStatusType,
  readonly PROXY_AUTHENTICATION_REQUIRED: HttpStatusType,
  readonly REQUEST_TIMEOUT: HttpStatusType,
  readonly CONFLICT: HttpStatusType,
  readonly GONE: HttpStatusType,
  readonly LENGTH_REQUIRED: HttpStatusType,
  readonly PRECONDITION_FAILED: HttpStatusType,
  readonly PAYLOAD_TOO_LARGE: HttpStatusType,
  readonly URI_TOO_LONG: HttpStatusType,
  readonly UNSUPPORTED_MEDIA_TYPE: HttpStatusType,
  readonly RANGE_NOT_SATISFIABLE: HttpStatusType,
  readonly EXPECTATION_FAILED: HttpStatusType,
  readonly IM_A_TEAPOT: HttpStatusType,
  readonly MISDIRECTED_REQUEST: HttpStatusType,
  readonly UNPROCESSABLE_CONTENT: HttpStatusType,
  readonly LOCKED: HttpStatusType,
  readonly FAILED_DEPENDENCY: HttpStatusType,
  readonly TOO_EARLY: HttpStatusType,
  readonly UPGRADE_REQUIRED: HttpStatusType,
  readonly PRECONDITION_REQUIRED: HttpStatusType,
  readonly TOO_MANY_REQUESTS: HttpStatusType,
  readonly REQUEST_HEADER_FIELDS_TOO_LARGE: HttpStatusType,
  readonly UNAVAILABLE_FOR_LEGAL_REASONS: HttpStatusType,
  readonly INTERNAL_SERVER_ERROR: HttpStatusType,
  readonly NOT_IMPLEMENTED: HttpStatusType,
  readonly BAD_GATEWAY: HttpStatusType,
  readonly SERVICE_UNAVAILABLE: HttpStatusType,
  readonly GATEWAY_TIMEOUT: HttpStatusType,
  readonly HTTP_VERSION_NOT_SUPPORTED: HttpStatusType,
  readonly VARIANT_ALSO_NEGOTIATES: HttpStatusType,
  readonly INSUFFICIENT_STORAGE: HttpStatusType,
  readonly LOOP_DETECTED: HttpStatusType,
  readonly NOT_EXTENDED: HttpStatusType,
  readonly NETWORK_AUTHENTICATION_REQUIRED: HttpStatusType,
};

export const HTTP_STATUS: HttpStatusesType = Object.freeze({
  CONTINUE: { CODE: 100 },
  SWITCHING_PROTOCOLS: { CODE: 101 },
  PROCESSING: { CODE: 102 },
  EARLY_HINTS: { CODE: 103 },
  OK: { CODE: 200 },
  CREATED: { CODE: 201 },
  ACCEPTED: { CODE: 202 },
  NON_AUTHORITATIVE_INFORMATION: { CODE: 203 },
  NO_CONTENT: { CODE: 204 },
  RESET_CONTENT: { CODE: 205 },
  PARTIAL_CONTENT: { CODE: 206 },
  MULTI_STATUS: { CODE: 207 },
  ALREADY_REPORTED: { CODE: 208 },
  IM_USED: { CODE: 226 },
  MULTIPLE_CHOICES: { CODE: 300 },
  MOVED_PERMANENTLY: { CODE: 301 },
  FOUND: { CODE: 302 },
  SEE_OTHER: { CODE: 303 },
  NOT_MODIFIED: { CODE: 304 },
  USE_PROXY: { CODE: 305 },
  SWITCH_PROXY: { CODE: 306 },
  TEMPORARY_REDIRECT: { CODE: 307 },
  PERMANENT_REDIRECT: { CODE: 308 },
  BAD_REQUEST: { CODE: 400 },
  UNAUTHORIZED: { CODE: 401 },
  PAYMENT_REQUIRED: { CODE: 402 },
  FORBIDDEN: { CODE: 403 },
  NOT_FOUND: { CODE: 404 },
  METHOD_NOT_ALLOWED: { CODE: 405 },
  NOT_ACCEPTABLE: { CODE: 406 },
  PROXY_AUTHENTICATION_REQUIRED: { CODE: 407 },
  REQUEST_TIMEOUT: { CODE: 408 },
  CONFLICT: { CODE: 409 },
  GONE: { CODE: 410 },
  LENGTH_REQUIRED: { CODE: 411 },
  PRECONDITION_FAILED: { CODE: 412 },
  PAYLOAD_TOO_LARGE: { CODE: 413 },
  URI_TOO_LONG: { CODE: 414 },
  UNSUPPORTED_MEDIA_TYPE: { CODE: 415 },
  RANGE_NOT_SATISFIABLE: { CODE: 416 },
  EXPECTATION_FAILED: { CODE: 417 },
  IM_A_TEAPOT: { CODE: 418 },
  MISDIRECTED_REQUEST: { CODE: 421 },
  UNPROCESSABLE_CONTENT: { CODE: 422 },
  LOCKED: { CODE: 423 },
  FAILED_DEPENDENCY: { CODE: 424 },
  TOO_EARLY: { CODE: 425 },
  UPGRADE_REQUIRED: { CODE: 426 },
  PRECONDITION_REQUIRED: { CODE: 428 },
  TOO_MANY_REQUESTS: { CODE: 429 },
  REQUEST_HEADER_FIELDS_TOO_LARGE: { CODE: 431 },
  UNAVAILABLE_FOR_LEGAL_REASONS: { CODE: 451 },
  INTERNAL_SERVER_ERROR: { CODE: 500 },
  NOT_IMPLEMENTED: { CODE: 501 },
  BAD_GATEWAY: { CODE: 502 },
  SERVICE_UNAVAILABLE: { CODE: 503 },
  GATEWAY_TIMEOUT: { CODE: 504 },
  HTTP_VERSION_NOT_SUPPORTED: { CODE: 505 },
  VARIANT_ALSO_NEGOTIATES: { CODE: 506 },
  INSUFFICIENT_STORAGE: { CODE: 507 },
  LOOP_DETECTED: { CODE: 508 },
  NOT_EXTENDED: { CODE: 510 },
  NETWORK_AUTHENTICATION_REQUIRED: { CODE: 511 },
});
